module.exports = __webpack_public_path__ + "static/media/robot.1d6bde12.svg";